<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">Vendez plus grâce à la location de fichier SMS</h1>
      <h2 class="title center__text">Louez votre liste de prospects téléphoniques</h2>
      

      
       <vue-modaltor :visible="open" @hide="hideModal">
        <template slot="close-icon">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            width="20"
            height="20"
            xml:space="preserve"
          >
            <path
              class="st0"
              fill="#0074D9"
              d="M8.7,7.6c-0.4-0.4-1-0.4-1.4,0C6.9,8,6.9,8.6,7.3,9l11,11l-11,11c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 l11-11l11,11c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-11-11L32,9c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-11,11L8.7,7.6z"
            />
          </svg>
        </template>
         
          <h1 class="center__text message">{{message}}</h1>
       
      </vue-modaltor>
       
      
      <h3>Servicesms.sn propose la location de fichiers clients ciblés et qualifiés pour ses campagnes d'envoi de SMS en masse :</h3>
      <li>Disposez de millions de numéros Opt-In pour atteindre un large public de clients potentiels</li>
      <li>Nos bases de données sont régulièrement mises à jour pour une efficacité optimale</li>
      <li>Profitez de centaines de critères de sélection pour cibler précisément votre offre</li>
      <p>
        Nous nous engageons à fournir un devis dans un délai de 48 à 72 heures, en fonction de vos besoins.
      </p>
      <p>
        En louant nos bases de données Opt-In, vous pouvez cibler des prospects qualifiés pour optimiser votre campagne.
      </p>
      <p>
        Servicesms.sn innove avec des opérations de Mobile Marketing via le SMS Opt-In, revitalisant ainsi les stratégies traditionnelles et enrichissant les campagnes publicitaires.
      </p>
      <h2>Bénéfices du SMS Opt-In</h2>
      <p>
        Le SMS offre une approche novatrice aux professionnels, présentant de multiples avantages :
      </p>
      <li><strong>Facile d'utilisation</strong> : Le SMS simplifie le processus de sélection de votre audience</li>
      <li><strong>Performant </strong>: Nous ciblons des utilisateurs ayant expressément opté pour recevoir des alertes SMS parmi une base de 12 millions d'individus, en utilisant des critères socio-démographiques et comportementaux avancés</li>
      <li>Votre message commercial atteint directement vos prospects, conférant au Mass SMS une influence unique que les autres médias ne possèdent pas.</li>
      <li><strong>Rapide</strong> : Notre plateforme SMS est conçue pour gérer des volumes massifs avec une exécution remarquablement rapide pour vos campagnes Opt-In.</li>
      <li><strong>Rentable</strong> : Le SMS Opt-In offre un excellent rapport efficacité/prix par rapport aux méthodes traditionnelles, assurant ainsi des retours sur investissement (ROI) satisfaisants avec des volumes comparables.</li>
      <li><strong>Parfaitement conforme à la loi</strong> : Les listings de nos partenaires sont enregistrées auprès de la CDP.</li>

      <h2>Réalisez vos objectifs de vente</h2>
      <p>
        Si vous avez envie de :
      </p>
      <li>Planifier une campagne publicitaire via SMS</li>
      <li>Annoncer un nouveau produit</li>
      <li>Conduire une enquête auprès d'une audience spécifique</li>
      <p>
        Notre solution Opt-in répond parfaitement aux exigences des professionnels de la communication.
      </p>
         <h2 class="center__text">
           <strong>Élargissez votre clientèle, attirez nouveaux prospects</strong>
      </h2>

       <div class="model__card seventy__container">
        <div class="card center__text">
          <img class="card__image" src="/../images//planification/geolocalisation.png" alt="">
          <router-link to="" class="card__description">Géolocalisation</router-link>
          <p>
            Région, Département, Ville, codes postaux...
          </p>

        </div>
        <div class="card center__text">
          <img class="card__image" src="/../images//planification/AGE1.png" alt="">
          <router-link to="" class="card__description">Age</router-link>
          <p>
             Jeunes, Adultes, Séniors

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/profession2.png" alt="">
          <router-link to="" class="card__description">Profession</router-link>
          <p>
            Artisan, commerçant, étudiants, Ouvrier...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/logement.png" alt="">
          <router-link to="" class="card__description">Logement</router-link>
          <p>
            Studio, appartement, Maison, Propriétaire / Locataire...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/smarphone.png" alt="">
          <router-link to="" class="card__description">Smartphone</router-link>
          <p>
            Apple, Adroide, windows phone,...

          </p>

        </div>

        
        <div class="card center__text">
          <img class="card__image" src="/../images//planification/famille.png" alt="">
          <router-link to="" class="card__description">Famille</router-link>
          <p>
            Nombre d'enfants, age des enfants,...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/sexe.png" alt="">
          <router-link to="" class="card__description">Sexe</router-link>
          <p>
            Homme, Femmes
          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/interet.png" alt="">
          <router-link to="" class="card__description">Centre d'intêrets</router-link>
          <p>
            Sport, Musique, Santé,...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/voiture.png" alt="">
          <router-link to="" class="card__description">Voitures</router-link>
          <p>
            Types, Marques,Modéles...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/csp++.png" alt="">
          <router-link to="" class="card__description">CSP++</router-link>
          <p>
            Cadres Supérieurs, Professions libérales,...

          </p>

        </div>

        <div class="card center__text">
          <img class="card__image" src="/../images//planification/revenue.png" alt="">
          <router-link to="" class="card__description">Revenus</router-link>
          <p>
            Niveaux de revenus
          </p>

        </div>

         <div class="card center__text">
          <img class="card__image" src="/../images//planification/animaux.png" alt="">
          <router-link to="" class="card__description">Animaux</router-link>
          <p>
            Nombre d'animaux domestiques, ...
          </p>
        </div>
      </div>
      
      <h2 class="title center__text">TARIFS</h2>
      <li>À partir de 85F TTC par contact loué, incluant le routage SMS sans frais cachés.</li>
      <h2>N'hésitez pas à nous contacter !</h2>
      <p>
        N'hésitez pas à nous appeler au +221 78 110 08 08 pour une solution clé en main adaptée à votre budget. Vous pouvez également nous contacter par email pour poser vos questions.
      </p>
      <!-- <h2 class="center__text">Remplissez le formulaire et obtenez une réponse rapide de la part de nos conseillers Services-SMS</h2>
      <form class="form sixty__container" @submit.prevent="sendEmail">
      <div>
        <span class="astrike">*</span>
      <input v-model="email" type="email" name="email" id="" placeholder="Email" required>
      </div>
      <div>
          <span class="astrike">*</span>
      <input v-model="number" @keypress="onlyNumber" type="text" name="number" id="" placeholder="Téléphone" required>
      </div>
      <div>
          <span class="astrike">*</span>
      <textarea  v-model="info" name="message"  id="" cols="30" rows="10" placeholder="Message" required></textarea>
       <button v-bind:disabled="!isDisabled" class="form__btn"  @click="open = true">ENVOYER</button>
    
      </div>
      
      </form> -->
    </section>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue';
import Navigation from "./Navigation";
import Footer from "./Footer";
import emailjs from 'emailjs-com';
import Revolution from "./Revolution.vue";
import VueModalTor from "vue-modaltor";
import VueAudio from 'vue-audio';
Vue.use(VueModalTor);
export default {
    data(){
     return{
         open:false,
         email:"",
         number:"",
         info:"",
         message:'Success',
         errMessage:"Fail try again",
        

     }
    },
  components: {
    Navigation,
    Footer,
  },
  methods:{
       sendEmail:(e)=>{
              
              emailjs.sendForm('service_bok9mag','template_2kk4j6v',e.target,'user_19zfhDvlt5iPo3XXiWrvc',this)
              .then((result)=>{
                  
                     return this.message;
              },(error)=>{
                  return errMessage;
                 console.log(error)
               
              })
          },
           onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
     hideModal() {
      this.open = false;
    },
  },
  computed:{
    isDisabled(){
      return this.email.length > 0 && this.number.length > 0 && this.message.length > 0;
    }
  }

};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
.message{
    color:$color-primary;
}
.astrike{
  display: inline-block;
  margin-left: 5rem;
  padding-top: .5rem;
}
.errMessage,.astrike{
    color:red;
}
input[type="text"],input[type="email"],textarea{
    width: 80%;
    display: block;
    margin: 0 auto;
    box-sizing: border-box;
    border: none;
   color: #555;
background-color: #fff;
background-image: none;
border: 1px solid #ccc;
border-radius: 4px;
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
margin-top: 1rem;
}
input[type="text"],input[type="email"]{
    height: 50px;
}
::placeholder{
  padding: 1rem;
  font-weight: bold;
}
.form__btn{
    display: block;
    width: 80%;
    margin: 1rem auto;
    padding: 1rem;
    background:$color-secondary;
    border: none;
    color: $color-white;
    font-weight: bold;
    cursor: pointer;
    &:hover{
        background: palevioletred;
    }
}
.card {
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  margin-top: 2rem;
  transition: transform .3s;

  &:hover{
    transform: scale(1.1); 
  }
}
.card__description{
     border-bottom: 4px solid $color-tertiary;
     border-width: 10px;
     text-align: center;
     font-weight: bolder;
     display:inline-block;
     text-decoration: none;
     color: #000;
}
@media (min-width: 64rem) {
  .top__container{
  margin-top:10rem;
 }
  .metres__head {
    top: 2rem;
  }
  .model__card{
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 2rem;
      
  }

  .last__card{
      margin-bottom: 2rem;

  }
}

</style>
